import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useSelector } from "react-redux";
import Select from "react-select";

import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from "reactstrap";
import UploadComponent from "../../Apps/Personalization/UploadComponent";

const screens = [
  {
    value: 'screen1',
    label: 'Tela 1',
  },
  {
    value: 'screen2',
    label: 'Tela 2',
  }
];

export default function NewFile(props) {
  const { isOpen, toggle } = props;
  const { token: jwt } = useSelector((state) => state.global_user_data.data);

  const [modalBackdrop, setModalBackdrop] = useState(false);

  //campos fomulário
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [screen, setScreen] = useState("");
  const [fileType, setFileType] = useState("");
  const [url, setUrl] = useState("");

  //validações campos formulários
  const [nameError, setNameError] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [screenError, setScreenError] = useState(false);
  const [urlError, setUrlError] = useState(false);

  //editado com sucesso
  const [success, setSuccess] = useState(false);

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  function resetFields() {
    setName("");
    setImage("");
    document.getElementById("formFile").value = "";
    setNameError(false);
    setImageError(false);
  }

  async function submitForm() {
    if (name === "") {
      return setNameError(true);
    } else setNameError(false);

    if (fileType === "file" && image === "") {
      return setImageError(true);
    } else setImageError(false);

    if (fileType === "link" && url === "") {
      return setUrlError(true);
    } else setUrlError(false);

    if (screen === "") {
      return setScreenError(true);
    } else setScreenError(false);

    if (fileType === "file") {
      const data = new FormData();
      data.append("files", image.files[0]);
      data.append("name", name);
      data.append("description", description);
    }

    resetFields();

    setSuccess(true)
  }

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      onClosed={() => {
        resetFields();
      }}
      autoFocus={true}
      centered={true}
    >
      {success && (
        <SweetAlert
          success
          title="Criado"
          onConfirm={() => {
            setSuccess(false);
            resetFields();
            toggle();
          }}
        >
          Documento criado com sucesso!
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Adicionar Arquivo</ModalHeader>
      <ModalBody>
        <form>
          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label className="form-label">Nome do documento*</label>
                <input
                  className="form-control"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {nameError && (
                  <p style={{ color: "red" }}>O campo Nome é obrigatório.</p>
                )}
              </Col>
            </Row>
          </div>
          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label className="form-label">Descrição</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Col>
            </Row>
          </div>
          <div>
            <div style={{display: 'flex', marginTop: 15}}>
              <Label style={{fontWeight: 700}}>Será informado um link ou um arquivo?</Label>
            </div>
            <div style={{display: 'flex'}}>
              <div style={{ marginRight: 30 }}>
                <Input
                  type="radio"
                  name="fileType"
                  value="link"
                  style={{ marginRight: 5 }}
                  id="link"
                  onChange={(e) => setFileType(e.target.value)}
                />
                <Label htmlFor="link" className="form-label">Link externo</Label>
              </div>
              <div style={{ marginRight: 30 }}>
                <Input
                  type="radio"
                  name="fileType"
                  value="file"
                  style={{ marginRight: 5 }}
                  id="file"
                  onChange={(e) => setFileType(e.target.value)}
                />
                <Label htmlFor="file" className="form-label">Anexar Arquivo</Label>
              </div>
            </div>
          </div>
          {fileType === "file" && (
            <UploadComponent
              id="formFile"
              labelText="Anexar arquivo*"
              setStateFunc={setImage}
              tipText="Apenas arquivos .jpg, .jpeg, .png e .gif"
            />
          )}
          {fileType === "link" && (
            <div>
              <Row style={{ marginTop: 10, marginBottom: 15 }}>
                <Col>
                  <label className="form-label">Link*</label>
                  <input
                    className="form-control"
                    type="text"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  />
                </Col>
              </Row>
            </div>
          )}
          {imageError && (
            <p style={{ color: "red" }}>
              O campo Anexar arquivo é obrigatório.
            </p>
          )}
          {urlError && (
            <p style={{ color: "red" }}>
              O campo Link é obrigatório.
            </p>
          )}
          <div>
            <div style={{display: 'flex'}}>
              <Label style={{fontWeight: 700}}>Selecione uma Tela</Label>
              <div id="screen-tip" style={{ height: "16px", paddingRight: "7px" }}>
                <div
                  className="show-tips"
                >
                  <span style={{ margin: 0 }}>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target="screen-tip"
                >
                  Segregar arquivos por tela.
                </UncontrolledTooltip>
              </div>
            </div>
            <Select
              placeholder='Selecione uma Tela'
              onChange={setScreen}
              options={[
                {
                  options: [
                    ...screens.map((e) => {
                      return { label: e.label, value: e.value };
                    }),
                  ],
                },
              ]}
              id="formFile"
            />
            {screenError && (
              <p style={{ color: "red" }}>
                É necessário selecionar uma tela.
              </p>
            )}
          </div>
          <Row
            style={{
              width: "100%",
              marginTop: 15,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="success"
              className="btn btn-success waves-effect waves-light"
              style={{ width: 80, marginTop: 10 }}
              onClick={submitForm}
            >
              Salvar
            </Button>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
